import script from "./JoinToTeam.vue?vue&type=script&setup=true&lang=js"
export * from "./JoinToTeam.vue?vue&type=script&setup=true&lang=js"

import "./JoinToTeam.vue?vue&type=style&index=0&id=1a4c6a69&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a4c6a69"]])

export default __exports__